
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/movable-ink",
      function () {
        return require("private-next-pages/destinations/movable-ink.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/movable-ink"])
      });
    }
  